var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analysis-graphs-container left"},[_c('fan-graphs'),_c('div',{staticClass:"navi-btn"},[_c('router-link',{staticClass:"back-btn",attrs:{"to":"/","tag":"button"}},[_c('span',[_vm._v(_vm._s(_vm.translate("back_btn")))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }